import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/buttons/button/button.component';
import {
    OrganizationPickerComponent,
} from '../../../components/organizations/organization-picker/organization-picker.component';
import * as gitVersion from '../../../../../../git.version.json';
import { CustomAuthService } from '../../../services/custom-auth.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-organization-not-found',
    templateUrl: './organization-not-found.component.html',
    styleUrls: ['./organization-not-found.component.scss'],
    imports: [OrganizationPickerComponent, ButtonComponent],
})
export class OrganizationNotFoundComponent {
    isAuthenticated = toSignal(this.authService.isAuthenticated$);

    constructor(
        private readonly authService: CustomAuthService,
    ) {
    }

    login() {
        this.authService.loginWithPopup();
    }

    get applicationVersion() {
        return gitVersion;
    }

    get currentYear() {
        return new Date().getFullYear();
    }

    get loggedIn() {
        return this.isAuthenticated();
    }

    protected readonly gitVersion = gitVersion;
    protected readonly Date = Date;
}
